module.exports = __webpack_public_path__ + "static/media/waiitng-illustration.4187240f.svg";